export default "__VITE_ASSET__CTT25FLo__"